/**
 * Dayjs Plugin Configuration
 *
 * Initializes dayjs with timezone and UTC plugins.
 * Import this file early in app initialization (main.tsx) to ensure
 * plugins are available globally before any component uses dayjs.
 */

import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

// Extend dayjs with timezone support
dayjs.extend(utc)
dayjs.extend(timezone)

export default dayjs
